/* eslint-disable @angular-eslint/component-selector */
/* eslint-disable @nx/enforce-module-boundaries */
import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  inject,
  Injector,
  OnDestroy,
  output,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AnimateOpenDirective } from '../../directives/animate-open.directive';
import { TextSearchComponent } from '../forms/text-search/text-search.component';
import { templateDrivenFormsViewProviders } from '../../directives/form.directive';
import { OrbitFormClaimService } from '../../services/orbit-form-claim.service';
import { SkeletonLoaderComponent } from '../skeleton-loader/skeleton-loader.component';
import { LookupOptionsService } from '../../services/lookup-options.service';
import { Option } from '../../types/lookup-options.interfaces';
import { take } from 'rxjs';

@Component({
  selector: 'orbit-model-number-capture',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    AnimateOpenDirective,
    TextSearchComponent,
    SkeletonLoaderComponent,
  ],
  templateUrl: './model-number-capture.component.html',
  styleUrl: './model-number-capture.component.scss',
  viewProviders: [templateDrivenFormsViewProviders],
})
export class OrbitModelNumberCaptureComponent implements OnDestroy {
  panelExpanded = signal(false);
  stillCantFindNumber = false;
  sendCannotFindNumber() {
    this.formService.updateModelNumberState(this.stillCantFindNumber);
  }
  orbitClaimService = inject(OrbitFormClaimService);
  formValue = signal<Partial<Record<string, any>>>({});
  submittingValue = signal<boolean>(false);
  formSubmitted = signal<boolean>(false);
  formValid = output<boolean>();
  loadingData = output<boolean>();
  activeStep = signal<any>('');
  productDescription = signal<string>('');
  valid = signal(false);
  errors = signal<string[]>([]);
  _destroyed = false;
  lookupOptions = inject(LookupOptionsService);
  options = signal<Option[]>([]);
  loading = signal(false);
  sub = null;

  errorMap = {
    modelNumberMissing: 'Please enter a model number.',
    modelNumberNotFound: 'Number not found. Check and try again.',
  };

  modelValue = '';

  private viewModel = computed(() => {
    const { plan } = this.orbitClaimService.plan() || { plan: undefined };
    return {
      stillCantFindNumber: this.stillCantFindNumber,
      panelExpanded: this.panelExpanded(),
      submittingValue: this.orbitClaimService.state.submittingValue,
      formValue: this.formValue(),
      brandImage: '',
      activeStep: this.orbitClaimService.state.currentStep,
      formSubmitted: this.formSubmitted(),
      valid: this.valid(),
      errors: this.errors(),
      productDescription:
        plan != undefined ? `${plan?.item?.code_description}` : '',
      errorMessage: this.formService.errorMessage(),
      guid: this.formService.state.claimData?.startTransaction?.gUID,
      options: this.options(),
      loading: this.loading(),
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(
    private readonly injector: Injector,
    private formService: OrbitFormClaimService
  ) {}
  ngOnDestroy(): void {
    this._destroyed = true;
  }

  onChange(value: any) {
    if (value) {
      this.formService.updateModelNumber(value);
    }
  }

  onEmptyResponse() {
    this.formService.errorMessage.set('Number not found. Check and try again.');
  }

  onTextChange(term: string) {
    this.formService.errorMessage.set(undefined);
    if (this.sub) this.sub.unsubscribe();
    this.loading.set(true);
    this.sub = this.lookupOptions
      .lookupOptionsForStep('', term)
      .pipe(take(1))
      .subscribe({
        next: (value) => {
          this.loading.set(false);
          if (!value) {
            value = [];
          }
          this.onTextChange;
          this.options.set(value);
          this.loadingData.emit(false);
          console.log(term);
          if (!this.vm.options.length && term) {
            this.onEmptyResponse();
            this.formService.dropdownOptions.set(false);
          } else {
            this.formService.errorMessage.set(undefined);
            this.formService.dropdownOptions.set(true);
          }
        },
        error: (error) => {
          console.error(error);

          this.loadingData.emit(false);
        },
      });
  }
}
